import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    email : "",
    name : "",
  },

  reducers: {
    setUser : (state,action) =>{
        state.email = action.payload.email;
        state.name = action.payload.name;
    },
  },
});

export const {
  setUser
} = userSlice.actions;
export const getEmail = (state) => state.user.email;
export const getName = (state) => state.user.name;
export default userSlice.reducer;
